import React, { useState } from 'react';
import {
  CloseButton,
  AddBp,
  AddLead
} from '../FloatingButtons/FloatingButtons';
import Backdrop from '../../../components/Ui/Backdrop/Backdrop';

const FloatingOptions = ({ show, clicked, rm }) => {
  const [addBpClicked, setAddBpClicked] = useState(false);

  return (
    <>
      <Backdrop class="bg-black-700 bg-opacity-75" show={show} />
      {rm ? <AddBp bpClick={setAddBpClicked} /> : null}
      {!addBpClicked ? (
        <>
          <AddLead />
          <CloseButton clicked={clicked} />
        </>
      ) : null}
    </>
  );
};

export default FloatingOptions;
